import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Typography, Grid } from '@mui/material';
import { CampaignState } from 'Stores/Slices/campaignSlice';
import { useAppSelector } from 'Stores/Hooks/hooks';
import { RootState } from 'Stores/store';

const PREFIX = 'CampaignTicker';

const classes = {
	root: `${PREFIX}-root`,
	campaignTitle: `${PREFIX}-campaignTitle`,
	campaignPrice: `${PREFIX}-campaignPrice`,
	mainGrid: `${PREFIX}-mainGrid`,
};

const Root = styled('div')(({ theme }) => ({
	[`&.${classes.root}`]: {
		display: 'flex',
		flexWrap: 'wrap',
		'& > *': {
			margin: theme.spacing(1),
			width: theme.spacing(25),
			height: theme.spacing(16),
		},
	},

	[`& .${classes.campaignTitle}`]: {
		fontSize: '16px',
	},

	[`& .${classes.campaignPrice}`]: {
		fontSize: '32px',
	},

	[`& .${classes.mainGrid}`]: {
		height: theme.spacing(16),
		backgroundColor: '#ddeef6',
		color: '#085DAD',
	},
}));

export default function CampaignTicker() {
	const campaignStore: CampaignState = useAppSelector(
		(state: RootState) => state.campaign,
	);
	const { campaign } = campaignStore;
	return (
		<Root className={classes.root}>
			<Paper elevation={3}>
				<Grid
					container
					xs={12}
					direction="column"
					justifyContent="center"
					alignItems="center"
					className={classes.mainGrid}>
					<Grid item>
						<Typography variant="h6" className={classes.campaignTitle}>
							Campaign Cost
						</Typography>
					</Grid>
					<Grid item>
						<Typography variant="h1" className={classes.campaignPrice}>
							₹ {campaign.price}
						</Typography>
					</Grid>
				</Grid>
			</Paper>
		</Root>
	);
}
